import { AdmService } from 'src/app/shared/services/adm.service';
import { Campania } from 'src/app/shared/models/campania';
import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { defaultValueOrRangeValidator, isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Pais } from 'src/app/shared/models/pais';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';


@Component({
  selector: 'app-campanias-dialog',
  templateUrl: './campanias-dialog.component.html'
})
export class CampaniasDialogComponent implements OnInit {
  mensaje: number = 0;
  form: FormGroup;
  idTipo: number;
  c: Campania;
  codigoCEdit: number = -1;
  mensajeErrorFecha: string;


  constructor(private admService: AdmService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<CampaniasDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.form = this.fb.group({
      idPais: [''],
      fechaDesde: ['', Validators.required],
      fechaHasta: ['', Validators.required],
      autor: [''],
      habilitacion: [true],
      codigo: [0]
    })
    if (data.idTipo != null) {
      this.idTipo = data.idTipo;
    }
    if (data.c != null) {
      this.codigoCEdit = data.c.codigo
      this.c = data.c

    }
  }
  public Etiquetas: {
    FechaDesde: string,
    FechaHasta: string
  }
  public Validaciones: {
    FechaDesde: string,
    FechaHasta: string
  }

  ngOnInit(): void {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Etiquetas = {
      FechaDesde: this.configService.etiquetas.FechaDesde,
      FechaHasta: this.configService.etiquetas.FechaHasta
    }
    this.Validaciones = {
      FechaDesde: this.configService.validaciones.FechaDesde,
      FechaHasta: this.configService.validaciones.FechaHasta
    }

      this.tablasService.cCampaniaDB(this.codigoCEdit)
      .subscribe((data: Campania) => {

      if (this.idTipo == 1) {
        let paisPlaceHolder: Pais = new Pais();
        paisPlaceHolder.id = this.loggedService.logged.idPais;
        paisPlaceHolder.descripcion = "";
        this.form.controls['idPais'].setValue(paisPlaceHolder.id);

      }

      if (typeof this.c != 'undefined') {
        if (this.codigoCEdit != -1) {
          if (data != null) {

            this.form.controls['idPais'].setValue(data.idPais);
            this.form.controls['habilitacion'].setValue(data.habilitacion);
            this.form.controls['codigo'].setValue(data.codigo);
            this.form.controls['autor'].setValue(data.autor);
            this.form.controls['fechaDesde'].setValue(data.fechaDesde);
            this.form.controls['fechaHasta'].setValue(data.fechaHasta);
            this.form.markAsUntouched();
            this.form.markAsPristine();
          }
        }
      }

    });
  }
  guardarCampania() {
    this.form.controls['autor'].setValue(this.loggedService.logged.userName);
    if (this.fechaValida()) {
      this.tablasService
        .mCampania(this.form.value)
        .subscribe((data: boolean) => {
          this.mensaje = this.idTipo;
          this.dialogRef.close();
        });

    } else {
      this.snackBarService.openSnackbar(this.configService.mensajes.TituloInfo, this.mensajeErrorFecha, 2, 1)
    }


  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

  clearInput(formControlName: string) {
    this.form.controls[formControlName].reset();
  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }


  fechaValida(): boolean {

    // var desde = Moment(this.form.controls['fechaDesde'].value);
    // var hasta = Moment(this.form.controls['fechaHasta'].value);
    // if (desde > hasta) {
    //   this.mensajeErrorFecha = this.configService.validaciones.RangoFechasValido;
    //   return false
    // }
    return true
  }

}
